export default __webpack_public_path__ + "static/media/userAvatar.804b3669.svg";